var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    {
      attrs: { flat: "", accordion: "", multiple: "" },
      model: {
        value: _vm.panel,
        callback: function($$v) {
          _vm.panel = $$v
        },
        expression: "panel"
      }
    },
    [
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage(
                      "properties_360.titles.work_order_management"
                    )
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("display-checkbox", {
                  staticClass: "px-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.contractual_commitment.specific_workorder_group"
                    ),
                    "input-value":
                      _vm.property.contractual_commitment
                        .specific_workorder_group
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "px-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.contractual_commitment.extranetUnderValidation"
                    ),
                    "input-value":
                      _vm.property.contractual_commitment
                        .extranetUnderValidation
                  }
                }),
                _vm._v(" "),
                _c("display-checkbox", {
                  staticClass: "px-2",
                  attrs: {
                    label: _vm.generateMessage(
                      "properties_360.fields.contractual_commitment.extranetCallingManagement"
                    ),
                    "input-value":
                      _vm.property.contractual_commitment
                        .extranetCallingManagement
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "pa-2", staticStyle: { width: "50%" } },
                [
                  _c("custom-simple-table", {
                    attrs: {
                      item: _vm.gestionFields,
                      "i18-path":
                        "properties_360.fields.contractual_commitment",
                      "table-units": [
                        "none",
                        "none",
                        "none",
                        "none",
                        "none",
                        "none",
                        "currency"
                      ],
                      "table-keys": [
                        "tech_in_charge",
                        "request_unique_phone",
                        "request_comment",
                        "included_labor_hours",
                        "included_interventions",
                        "supplies_included",
                        "amount_supplies_included"
                      ]
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column pa-2",
                  staticStyle: { width: "50%" }
                },
                [
                  _c("custom-simple-table", {
                    attrs: {
                      item: _vm.property.contractual_commitment,
                      "i18-path":
                        "properties_360.fields.contractual_commitment",
                      "table-keys": [
                        "customer_name",
                        "customer_type",
                        "customer_phone"
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("maintenance-contract-infos")
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.generateMessage("properties_360.titles.orders")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("custom-simple-table", {
                attrs: {
                  item: _vm.property,
                  "i18-path": "properties_360.fields",
                  "table-keys": [
                    "reactive_instructions",
                    "operator_instructions",
                    "dispatcher_instructions"
                  ]
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage(
                      "properties_360.titles.maintenance_plan"
                    )
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("v-data-table", {
                staticClass: "secondarybackground",
                attrs: {
                  dense: "",
                  "no-data-text": "Aucun plan associé à cette installation",
                  headers: _vm.planHeaders,
                  items: _vm.plans,
                  "disable-pagination": "",
                  "hide-default-footer": ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }